import { Component, isDevMode, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ValidationService } from 'src/app/services/common/validation.service';
import { ThemingService } from '../../services/common/theming.service';
import { AuthService } from '../auth.service';


@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    public validationService: ValidationService,
    private authService: AuthService,
    private router : Router,
    private themingService: ThemingService) {
  }

  ngOnInit() {
    localStorage.removeItem('OrganizationCode');
    localStorage.removeItem('breadcrumbs');
    localStorage.removeItem('title');

    if (isDevMode) {
      var orgCode = localStorage.getItem('OrganizationCode');
      localStorage.setItem('OrganizationCode', orgCode);
    }
  }

  signin() {
    this.authService.login();
  }

  home() {
    this.router.navigateByUrl('/');
  }
}
